import React, { useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-185.1 · outside Kenya check on published events. Preview first; apply needs the exact count.
const box = { padding: 16, borderRadius: 14, border: "1px solid var(--ww-line)", background: "var(--ww-surface)" };
const btn = (bg, color) => ({ padding: "10px 16px", borderRadius: 10, border: `1px solid ${bg}`, background: bg, color,
  fontFamily: "Poppins", fontWeight: 700, fontSize: 13, textTransform: "lowercase", cursor: "pointer", minHeight: 40 });

export const CountryHoldPanel = () => {
  const [preview, setPreview] = useState(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setPreview((await client.get("/admin/country-hold/preview")).data); setTyped(""); }
    catch { toast.error("preview failed"); } finally { setBusy(false); }
  };
  const apply = async () => {
    setBusy(true);
    try {
      const r = await client.post("/admin/country-hold/apply", { confirm_count: Number(typed) });
      toast.success(r.data.noop ? "nothing to hold" : `held ${r.data.held} events`);
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail?.message || "apply failed"); } finally { setBusy(false); }
  };
  const n = preview?.would_hold ?? 0;
  return (
    <div data-testid="ops-card-country-hold" style={box}>
      <h2 style={{ fontFamily: "Poppins", fontWeight: 800, fontSize: 18 }}>WW-185.1 · outside kenya check on queue and published rows</h2>
      <p style={{ fontFamily: "Arial", fontSize: 13, color: "var(--ww-text-muted)", marginTop: 4 }}>
        a blank or kenya country with a place outside kenya in the title, venue text or picked venue is held for the safari section. rows staff confirmed as kenya are skipped. nobody presses apply until vania says yes.
      </p>
      <button data-testid="country-hold-preview" className="mt-3" onClick={load} disabled={busy} style={btn("transparent", "var(--ww-text)")}>preview</button>
      {preview && (
        <div className="mt-3" style={{ fontFamily: "Arial", fontSize: 13 }}>
          <p data-testid="country-hold-summary">would hold <b data-testid="country-hold-count">{n}</b> rows · {preview.queue ?? 0} in the queue, {preview.published ?? 0} published</p>
          <ul data-testid="country-hold-list" className="mt-2" style={{ maxHeight: 260, overflow: "auto" }}>
            {preview.rows.map((r) => (
              <li key={r.id} data-testid={`country-hold-row-${r.id}`}>
                <span data-testid={`country-hold-kind-${r.id}`}>{r.kind || "published"}</span> · {(r.start_at || "no date").slice(0, 10)} · <b>{r.title}</b> · now {r.country_now || "blank"} · suggested {r.would_set} · {r.reason}
              </li>
            ))}
          </ul>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <input data-testid="country-hold-confirm-input" value={typed} onChange={(e) => setTyped(e.target.value.replace(/\D/g, ""))}
              placeholder={`type ${n} to confirm`} style={{ height: 40, padding: "0 10px", borderRadius: 10, border: "1px solid var(--ww-line-strong)", background: "transparent", color: "var(--ww-text)" }} />
            <button data-testid="country-hold-apply" onClick={apply} disabled={busy || !n || Number(typed) !== n}
              style={{ ...btn("#D64545", "#FFFFFF"), opacity: busy || !n || Number(typed) !== n ? 0.5 : 1 }}>
              hold {n} rows
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
